<template>
    <rect id="fog" width="100%" height="100%" fill="white" opacity="1" />
</template>

<script>
export default {
    name: 'FogComponent'
};
</script>
